import type { SerializedCustomerMe } from '@enmon/commons/lib/enmon';
import { authActions } from '../App/actions';
import { CHANGE_IS_MOBILE } from './constants';

const initialState = {
  isMobile: false,
  customerConfig: undefined as SerializedCustomerMe['config'] | undefined,
};

type State = typeof initialState;

type LogoutCustomerSuccessAction = ReturnType<typeof authActions.logoutFromCustomer.success>;
type LogoutSuccessAction = ReturnType<typeof authActions.logout.success>;
type LoadSessionSuccessAction = ReturnType<typeof authActions.loadSession.success>;

type Action =
  | { type: typeof CHANGE_IS_MOBILE; payload: boolean }
  | LogoutCustomerSuccessAction
  | LogoutSuccessAction
  | LoadSessionSuccessAction;

function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case CHANGE_IS_MOBILE:
      return { ...state, isMobile: action.payload as boolean };

    case authActions.loadSession.success.type: {
      const { customerData } = (action as LoadSessionSuccessAction).payload || {};
      return {
        ...state,
        customerConfig: customerData?.config,
      };
    }

    case authActions.logoutFromCustomer.success.type:
    case authActions.logout.success.type:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
